(function () {
  function slugify(text) {
    return (text || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function buildToc() {
    var tocNav = document.querySelector('.blog-toc');
    if (!tocNav) return;

    var tocList = tocNav.querySelector('.blog-toc__list');
    if (!tocList) return;

    var contentWrapper =
      document.querySelector('.article__content .rte') ||
      document.querySelector('.article__content');
    if (!contentWrapper) return;

    var headings = contentWrapper.querySelectorAll('h2');
    if (!headings.length) return;

    var usedSlugs = {};

    headings.forEach(function (heading) {
      if (!heading.id) {
        var baseSlug = slugify(heading.textContent) || 'section';
        var slug = baseSlug;
        var count = 1;
        while (usedSlugs[slug]) {
          slug = baseSlug + '-' + count;
          count += 1;
        }
        usedSlugs[slug] = true;
        heading.id = slug;
      } else {
        usedSlugs[heading.id] = true;
      }

      // A block can supply a shorter label for its TOC pill via data-toc-label (see the
      // "Table of contents label" setting on Text / Benefits table / FAQ blocks in
      // sections/main-article-journal.liquid). The on-page heading is left untouched; only
      // this pill's text changes. Falls back to the heading's own text when unset or blank.
      var customLabel = heading.getAttribute('data-toc-label');
      var label = customLabel && customLabel.trim() ? customLabel.trim() : heading.textContent;

      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = label;
      tocList.appendChild(link);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToc);
  } else {
    buildToc();
  }
})();
